"use strict";

const MuniHardAssetFactSheetController = function () {
  const assetTypeConfig = {
    pipe: {
      routeName: "pipe-fact-sheet",
      apiAssetType: "pipe",
      analyticsName: "pipes",
      layerName: "muniPipes",
      displayName: "Pipe",
    },
    manhole: {
      routeName: "manhole-fact-sheet",
      apiAssetType: "manhole",
      analyticsName: "manholes",
      layerName: "muniManhole",
      displayName: "Manhole",
    },
    culvert: {
      routeName: "culvert-fact-sheet",
      apiAssetType: "culvert",
      analyticsName: "culverts",
      layerName: "muniCulvert",
      displayName: "Culvert",
    },
    openChannel: {
      routeName: "open-channel-fact-sheet",
      apiAssetType: "openChannel",
      analyticsName: "open-channels",
      layerName: "muniOpenChannel",
      displayName: "Open Channel",
    },
    liftStation: {
      routeName: "lift-station-fact-sheet",
      apiAssetType: "liftStation",
      analyticsName: "lift-stations",
      layerName: "muniLiftStations",
      displayName: "Lift Station",
    },
    cleanout: {
      routeName: "cleanout-fact-sheet",
      apiAssetType: "cleanout",
      analyticsName: "cleanouts",
      layerName: "muniCleanout",
      displayName: "Cleanout",
    },
  };

  const deleteAssetByType = {
    pipe: (id) => ApiCalls.deletePipe(id),
    manhole: (id) => ApiCalls.deleteManhole(id),
    culvert: (id) => ApiCalls.deleteCulvert(id),
    openChannel: (id) => ApiCalls.deleteOpenChannel(id),
    liftStation: (id) => ApiCalls.deleteLiftStation(id),
    cleanout: (id) => ApiCalls.deleteCleanout(id),
  };

  const createRouteHandler = function (assetKey) {
    return function ({ data, hashString }) {
      open(assetKey, data.id, { highlightId: hashString });
    };
  };

  const pipeFactSheetRoute = {
    as: assetTypeConfig.pipe.routeName,
    handler: createRouteHandler("pipe"),
  };

  const pipeFactSheetHighlightRoute = {
    as: `${assetTypeConfig.pipe.routeName}-highlight`,
    handler: pipeFactSheetRoute.handler,
  };

  const manholeFactSheetRoute = {
    as: assetTypeConfig.manhole.routeName,
    handler: createRouteHandler("manhole"),
  };

  const manholeFactSheetHighlightRoute = {
    as: `${assetTypeConfig.manhole.routeName}-highlight`,
    handler: manholeFactSheetRoute.handler,
  };

  const culvertFactSheetRoute = {
    as: assetTypeConfig.culvert.routeName,
    handler: createRouteHandler("culvert"),
  };

  const culvertFactSheetHighlightRoute = {
    as: `${assetTypeConfig.culvert.routeName}-highlight`,
    handler: culvertFactSheetRoute.handler,
  };

  const openChannelFactSheetRoute = {
    as: assetTypeConfig.openChannel.routeName,
    handler: createRouteHandler("openChannel"),
  };

  const openChannelFactSheetHighlightRoute = {
    as: `${assetTypeConfig.openChannel.routeName}-highlight`,
    handler: openChannelFactSheetRoute.handler,
  };

  const liftStationFactSheetRoute = {
    as: assetTypeConfig.liftStation.routeName,
    handler: createRouteHandler("liftStation"),
  };

  const liftStationFactSheetHighlightRoute = {
    as: `${assetTypeConfig.liftStation.routeName}-highlight`,
    handler: liftStationFactSheetRoute.handler,
  };

  const cleanoutFactSheetRoute = {
    as: assetTypeConfig.cleanout.routeName,
    handler: createRouteHandler("cleanout"),
  };

  const cleanoutFactSheetHighlightRoute = {
    as: `${assetTypeConfig.cleanout.routeName}-highlight`,
    handler: cleanoutFactSheetRoute.handler,
  };

  var getConfig = function (assetKey) {
    const config = assetTypeConfig[assetKey];
    const SortUtilities = require("../general/sortUtilities");
    const alphaSorter = SortUtilities.alphaSorter;

    return {
      template: "factSheet/hardAsset/hardAssetFactSheet.njk",
      pointColumnName: "geom",
      iconFunction: getIconClass,
      closeUrl: UrlRoutes.getDefaultUrl(),
      goToMapFunction: () => Analytics.sendDataListEvent("address_to_map"),
      getDataFunction: (id) => getData(config.apiAssetType, id),
      prepareDataFunction: prepareData,
      onCloseFunction: onClose,
      afterOpenFunction: afterOpen,
      readOnlyPhotos: true,
      apiAssetName: config.apiAssetType,
      dataSorting: {
        history: { key: "date", reversed: true },
      },
      tableTemplates: {
        history: "factSheet/hardAsset/hardAssetHistoryRows.njk",
      },
      sortersDict: {
        inspectionTypeName: alphaSorter,
        date: alphaSorter,
        inspectionDisplayDate: alphaSorter,
        displayCondition: alphaSorter,
        assetId: alphaSorter,
      },
    };
  };

  var getIconClass = function () {
    return "icon-hard-asset";
  };

  var getData = async function (assetType, id) {
    try {
      return await ApiCalls.getHardAssetForFactSheet(assetType, id);
    } catch (e) {
      ApiError.assertIs(e);
      if (e.status === 404) {
        return e;
      }
      throw e;
    }
  };

  var prepareData = function (data) {
    data.showMaintenanceZone = Tree.get("availableDataSortLayers").includes("maintenanceZones");
    data.readOnlyTopLevel = Session.isRegulator();
    FactSheetNew.addDisplayDates(data.history);
    data.dataView = Tree.get("dataView");
    data.phaseColor = data.phase ? BmpFcsIcon.getIconColorByPhase(data.phase, true) : "#ffffff";
    data.phaseTextColor = Misc.isDarkColor(data.phaseColor) ? "#fff" : "#000";
    data.assetAge = AssetsPopupFunctions.getAssetAge(data.installDate);
    data.permissions = UserPermissions.getAllPermissions();
    data.canEditInventory = HardAssetInventoryModalController.canEditInventory(data.assetType);

    const inspectionUiEnabled = HardAssetInspectionGate.isEnabledForAssetType(data.assetType);
    data.canCreateRoutineInspection = data.canCreateRoutineInspection && inspectionUiEnabled;
    for (const historyItem of data.history) {
      historyItem.canCreateRoutineInspection =
        historyItem.canCreateRoutineInspection && inspectionUiEnabled;
    }
  };

  var open = async function (assetKey, id, options = {}) {
    FactSheetNew.open(id, getConfig(assetKey), null, options);
  };

  var afterOpen = function () {
    _loadListeners();
    _handleSectionDisplay();
  };

  var _unloadListeners = function () {
    $("#fact-sheet-container")
      .off("click", ".download-report", _downloadReportClick)
      .off("click", ".download-file", _downloadFile)
      .off("click", ".hard-asset-delete-button", _hardAssetDeleteButtonClick)
      .off("click", ".js-edit-assessment", _editAssessmentClick)
      .off("click", ".delete-inspection", _deleteInspectionClick)
      .off("click", ".open-dry-weather-screening", _openDryWeatherScreeningClick)
      .off("click", ".open-hard-asset-inventory", _openInventoryClick);
  };

  var _loadListeners = function () {
    _unloadListeners();
    $("#fact-sheet-container")
      .on("click", ".download-report", _downloadReportClick)
      .on("click", ".download-file", _downloadFile)
      .on("click", ".hard-asset-delete-button", _hardAssetDeleteButtonClick)
      .on("click", ".js-edit-assessment", _editAssessmentClick)
      .on("click", ".delete-inspection", _deleteInspectionClick)
      .on("click", ".open-dry-weather-screening", _openDryWeatherScreeningClick)
      .on("click", ".open-hard-asset-inventory", _openInventoryClick);
  };

  var _editAssessmentClick = function () {
    const data = FactSheetNew.$getRow($(this)).data();
    MuniPopup.editHistory(data);
  };

  var _openInventoryClick = function () {
    HardAssetInventoryModalController.invokeHardAssetInventoryModal(
      FactSheetNew.getId(),
      FactSheetNew.getData().assetType,
      "hard-asset-general-info",
    );
  };

  var _openDryWeatherScreeningClick = function () {
    const id = FactSheetNew.getId();
    const assetType = $(this).data("assetType");
    DryWeatherFunctions.openDryWeatherScreening(id, assetType);
  };

  var onClose = function () {
    _unloadListeners();
  };

  var _handleSectionDisplay = function () {
    const $factSheetContainer = $("#fact-sheet-container");
    $factSheetContainer
      .find("#hard-asset-general-info-section")
      .find(".fact-group")
      .each(function () {
        if ($(this).find(".fact-item.hide").length === $(this).find(".fact-item").length) {
          $(this).addClass("hide");
        }
      });
  };

  var _downloadReportClick = async function () {
    const $row = FactSheetNew.$getRow($(this));
    const data = $row.data();
    Analytics.sendPopupEvent("download_report", data.assetType);
    await ApiCalls.downloadMuniInspectionPdf(data.id, data.assetType);
  };

  var _downloadFile = function (e) {
    const factSheetData = FactSheetNew.getData();
    const fileData = $(e.currentTarget).parents("[data-category=permit]").data();
    if (fileData.fileId) {
      ApiCalls.downloadHardAssetFile(factSheetData.assetType, fileData.fileId);
    }
  };

  var _hardAssetDeleteButtonClick = function () {
    const data = FactSheetNew.getData();
    const config = assetTypeConfig[data.assetType];
    const id = FactSheetNew.getId();
    const name = data.name || data.assetId;

    MessageModal.showConfirmWarningModal(
      `Delete ${config.displayName} ${name}? Click "Delete" to permanently delete the ${config.displayName}. Click "Cancel" to return.`,
      async function () {
        await deleteAssetByType[data.assetType](id);
        InspectableAssetCache.removeAsset(data.assetType, id);
        LayerFunctions.getLayerModule(config.layerName).invalidateLayerData();
        FactSheetNew.close();
      },
      "Cancel",
      "Delete",
    );
    Analytics.sendPopupEvent("delete_asset", config.analyticsName);
  };

  var _deleteInspectionClick = function () {
    const $row = FactSheetNew.$getRow($(this));
    const data = $row.data();
    const factSheetData = FactSheetNew.getData();
    const config = assetTypeConfig[factSheetData.assetType];

    MessageModal.showDeleteRecordModal(async function () {
      await ApiCalls.deleteMuniInspection(data.id, data.assetType);
      InspectableAssetCache.refreshAsset(factSheetData.assetType, FactSheetNew.getId());
      $row.remove();
      LayerFunctions.getLayerModule(config.layerName).invalidateLayerData();
      Analytics.sendPopupEvent("delete_inspection", data.assetType);
    });
  };

  return {
    assetTypeConfig,
    pipeFactSheetRoute,
    pipeFactSheetHighlightRoute,
    manholeFactSheetRoute,
    manholeFactSheetHighlightRoute,
    culvertFactSheetRoute,
    culvertFactSheetHighlightRoute,
    openChannelFactSheetRoute,
    openChannelFactSheetHighlightRoute,
    liftStationFactSheetRoute,
    liftStationFactSheetHighlightRoute,
    cleanoutFactSheetRoute,
    cleanoutFactSheetHighlightRoute,
    open,
    getConfig,
  };
};

module.exports = MuniHardAssetFactSheetController();

const ApiCalls = require("../apiCalls");
const ApiError = require("../errors/apiError");
const FactSheetNew = require("../general/factSheetNew");
const Analytics = require("../general/analytics");
const Session = require("../login/session");
const UserPermissions = require("../login/userPermissions");
const Tree = require("../tree");
const Misc = require("../misc");
const BmpFcsIcon = require("../bmpfcs/bmpFcsIcon");
const AssetsPopupFunctions = require("../assetManagement/assetsPopupFunctions");
const MessageModal = require("../modals/messageModal");
const LayerFunctions = require("../layerFunctions");
const UrlRoutes = require("../routes/urlRoutes");
const DryWeatherFunctions = require("../illicitDischarge/dryWeatherFunctions");
const HardAssetInspectionGate = require("./hardAssetInspectionGate");
const HardAssetInventoryModalController = require("./hardAssetInventoryModalController");
const InspectableAssetCache = require("../offline/inspectableAssetCache");
const MuniPopup = require("./muniPopup");
